import Vue from 'vue'
import VueRouter from 'vue-router'
import Meetings from '../components/meeting/Meetings.vue'
import People from '../components/people/People.vue'
import Attendance from '../components/Attendance.vue'
import Notifications from '../components/Notifications.vue'
import Create from '../components/meeting/Create.vue'
import MeetingDetail from '../components/meeting/MeetingDetails.vue'
import LandingPage from '../components/LandingPage.vue'
import SignIn from '../components/SignIn.vue'
import auth from "@/middleware/auth";

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Your Meeting List',
    component: LandingPage,
    meta: {
      title: 'FISHER MEETINGS | Your Meetings'
    }
  },
  {
    path: '/meetings',
    name: 'Meetings',
    component: Meetings,
    meta: {
      title: 'FISHER MEETINGS | Meetings',
      middleware: [auth]
    },
    children:[
       {path: ':id', name: 'meetingDetail', component: MeetingDetail}
    ]
  },
  {
    path: '/create',
    name: 'CreateMeeting',
    component: Create,
    meta: {
      title: 'FISHER MEETINGS | Create Meeting',
      middleware: [auth]
    }
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
    meta: {
      title: 'FISHER MEETINGS | Sign In'
    }
  },


  {path:'*', redirect:'/meetings'}
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

function nextFactory(context, middleware, index) {

  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default `next()` callback is returned.

  if (!subsequentMiddleware) return context.next;
  return (...parameters) => {
    // Run the default Vue Router `next()` callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // `nextMiddleware()` callback.

    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({...context, next: nextMiddleware});
  };
}
router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
        ? to.meta.middleware
        : [to.meta.middleware];

    const context = {
          from,
          next,
          router,
          to,
        };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({...context, next: nextMiddleware});
  }
  return next();
});
export default router
